module.exports = __webpack_public_path__ + "static/media/thegrguide.23272a18.jpg";